import React from 'react'
import { Modules } from 'src/components/modules'

type ModuleProps = {
  _key: string
  _type: string
  backgroundImage?: unknown
  mobileBackgroundImage?: unknown
}

type RenderModulesOptions = {
  priorityFirstModuleImage?: boolean
}

export const RenderModules = (
  modules?: ModuleProps[],
  options: RenderModulesOptions = {}
) => {
  if (modules) {
    return modules?.map((module, index) => {
      const priorityImage = Boolean(
        options.priorityFirstModuleImage &&
          index === 0 &&
          module._type === 'layoutSection' &&
          (module.backgroundImage || module.mobileBackgroundImage)
      )

      return (
        <React.Fragment key={module._key}>
          <Modules
            type={module._type}
            reactModule={module}
            priorityImage={priorityImage}
          />
        </React.Fragment>
      )
    })
  }
}
